import {IApiEndpoints} from "../typings/apiEndpoints";
import {IApiGameAccountDescription} from "../typings/apiResponse";
import * as angular from "angular";

export class GameAccountDescriptionResource {
    public static $inject = ["$http", "ApiEndpoints"];
    constructor(private $http:angular.IHttpService, private ApiEndpoints:IApiEndpoints) {

    }

    getGameAccountDescriptions(): angular.IPromise<IApiGameAccountDescription[]> {
        return this.$http.get(this.ApiEndpoints.gameAccountDescription).then(
            function (response: angular.IHttpPromiseCallbackArg<Array<IApiGameAccountDescription>>) {
                return response.data;
            }
        );
    }

    getGameAccountDescription(gameAccountDescriptionId: string): angular.IPromise<IApiGameAccountDescription> {
        return this.$http.get(this.ApiEndpoints.gameAccountDescription + '/' + gameAccountDescriptionId).then(
            function (response: angular.IHttpPromiseCallbackArg<IApiGameAccountDescription>) {
                return response.data;
            }
        );
    }
}
